import {FC, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Loading} from '../../../../components/Loading/Loading'
import {GET, POST, PUT} from '../../../../services/api'
import {i18n} from '../../../../translate/i18n'
import Swal from 'sweetalert2'
import styles from './frenet.module.css'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {Button} from '../../../../components/Button/Button'
import FrenetImg from '../../../../assets/freights/frenet-full.png'
import {Input} from '../../../../components/Input/Input'
import ReactLoading from 'react-loading'
import usePluginsSpace from '../../../../hooks/usePluginSpace'

type PluginconfigResponseType = {
  id: number
  name: string
  plugintypeId: number
  plugintemplateId: number
  content: ContentFrenetType
}

type ContentFrenetType = {
  able: boolean
  token: string
  declaredValue: boolean
}

type JadlogResponseType = {
  id: string
  nickName: string
}

const FrenetContent: FC = () => {
  const navigate = useNavigate()
  const {integrations} = usePluginsSpace()
  const [loading, setLoading] = useState(false)
  const [hasConfig, setHasConfig] = useState(false)
  const [id, setId] = useState(0)
  const [able, setAble] = useState(true)
  const [token, setToken] = useState('')
  const [declaredValue, setDeclaredValue] = useState(false)
  const [branchCode, setBranchCode] = useState('none')
  const [validToken, setValidToken] = useState(true)
  const [loadingToken, setLoadingToken] = useState(false)
  const [jadlogPosts, setJadlogPosts] = useState([
    {
      value: 'none',
      select: 'Selecione um ponto de postagem',
    },
  ])

  // const getJadlogPosts = async (tk: string) => {
  //   try {
  //     const jadlogPostsRes = await POST(`/frenet/jadlog`, {
  //       token: tk
  //     })
  //     if(jadlogPostsRes.data && jadlogPostsRes.success && jadlogPostsRes.data.length > 0){
  //       const jadLogSelect = jadlogPostsRes.data.map((jdPost: JadlogResponseType) => ({
  //         value: jdPost.id,
  //         select: jdPost.nickName
  //       }))
  //       setJadlogPosts([...jadlogPosts, ...jadLogSelect])
  //     }
  //   } catch(e){
  //     console.log(e)
  //   }
  // }

  const getFrenet = async () => {
    try {
      const pluginconfigRes = await GET(`/pluginconfig`)
      const pluginconfigFinded = pluginconfigRes.data.find(
        (pgConfig: PluginconfigResponseType) => pgConfig.plugintemplateId === 119
      )
      if (pluginconfigFinded && pluginconfigFinded.content) {
        setHasConfig(true)
        setId(pluginconfigFinded.id)
        setAble(pluginconfigFinded.content.able)
        setToken(pluginconfigFinded.content.token)
        setDeclaredValue(pluginconfigFinded.content.declaredValue)
        setBranchCode(
          pluginconfigFinded.content.branchCode ? pluginconfigFinded.content.branchCode : 'none'
        )
        // await getJadlogPosts(pluginconfigFinded.content.token)
      }
    } catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao obter configuração!',
      }).then(() => {
        navigate('/configuracoes/taxa-entrega')
      })
    }
  }
  const save = async () => {
    try {
      if (!validToken) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Token inválido!',
        })
        return
      }
      let error = false
      setLoading(true)
      if (hasConfig) {
        const result = await PUT(`/pluginconfig/${id}`, {
          content: {able, token, declaredValue, branchCode},
        })
        if (!result.success) error = true
      } else {
        const result = await POST(`/pluginconfig`, {
          plugintypeId: 1,
          plugintemplateId: 119,
          name: 'Frenet',
          content: {able, token, declaredValue, branchCode},
        })
        if (!result.success) error = true
      }
      setLoading(false)
      if (error) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao alterar configuração!',
        }).then(() => navigate('/configuracoes/taxa-entrega'))
      } else {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Configuração salva com sucesso!',
        }).then(() => navigate('/configuracoes/taxa-entrega'))
      }
    } catch (e) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao alterar configuração!',
      })
    }
  }

  const verifyToken = async () => {
    try {
      setValidToken(true)
      setLoadingToken(true)
      const jadlogPostsRes = await POST(`/frenet/jadlog`, {
        token,
      })
      setLoadingToken(false)
      if (jadlogPostsRes.data && jadlogPostsRes.success && jadlogPostsRes.data.length > 0) {
        setValidToken(true)
      } else {
        setValidToken(false)
      }
    } catch (e) {
      setLoadingToken(false)
      setValidToken(false)
      console.log(e)
    }
  }

  const init = async () => {
    setLoading(true)
    await getFrenet()
    setLoading(false)
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`frenet.title`)}</span>
              </h3>
            </div>
            <div className='card-body d-flex flex-column gap-5'>
              <div className={styles.goBack}>
                <img src={FrenetImg} alt='Frenet' />
                {/* <p onClick={() => navigate('/configuracoes/taxa-entrega')}>
                  {i18n.t(`frenet.back`)}
                </p> */}
              </div>
              <div className={styles.configItem}>
                <h2>{i18n.t(`frenet.integration`)}</h2>
                <div className={styles.configInput}>
                  <Input
                    inputAttr={{
                      type: 'text',
                    }}
                    placeholder={'-'}
                    label={'Token'}
                    name={'Token'}
                    value={token}
                    change={setToken}
                    blur={() => verifyToken()}
                    alarm={token && !validToken ? true : false}
                    alarmText={i18n.t(`frenet.valid_token`)}
                    toolTip={true}
                    toolTipIcon={'info-circle'}
                    toolTiptext={String(i18n.t(`frenet.getToken`))}
                  />
                  {loadingToken && (
                    <div className='d-flex flex-row gap-2 align-items-center'>
                      <ReactLoading type='spin' color='#D5D5D5' height={15} width={15} />
                      <p className='fw-normal text-gray-600 mt-4'>Validando</p>
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.configItem}>
                <h2>{i18n.t(`frenet.config`)}</h2>
                {/* <p>{i18n.t(`frenet.dimensions`)}</p>
                    <div className={styles.configDimensions}>
                        <Input
                            inputAttr={{
                            type: 'text',
                            }}
                            placeholder={'-'}
                            label={i18n.t(`frenet.height`)}
                            name={i18n.t(`frenet.height`)}
                            change={() => { }}
                        />
                        <Input
                            inputAttr={{
                            type: 'text',
                            }}
                            placeholder={'-'}
                            label={i18n.t(`frenet.width`)}
                            name={i18n.t(`frenet.width`)}
                            change={() => { }}
                        />
                        <Input
                            inputAttr={{
                            type: 'text',
                            }}
                            placeholder={'-'}
                            label={i18n.t(`frenet.length`)}
                            name={i18n.t(`frenet.length`)}
                            change={() => { }}
                        />
                    </div> */}
                <Input
                  inputAttr={{
                    type: 'select',
                  }}
                  label={i18n.t('frenet.value')}
                  options={[
                    {
                      select: i18n.t(`frenet.use`),
                      value: true,
                    },
                    {
                      select: i18n.t(`frenet.dont_use`),
                      value: false,
                    },
                  ]}
                  value={declaredValue}
                  change={setDeclaredValue}
                  smalltext={i18n.t('frenet.declared_value')}
                />
                {/* <Input
                        inputAttr={{
                            type: 'select',
                        }}
                        label={i18n.t('frenet.branchCode')}
                        options={jadlogPosts}
                        value={branchCode}
                        change={setBranchCode}
                    /> */}
                {/* <Input
                        inputAttr={{
                            type: 'select',
                        }}
                        label={i18n.t('frenet.price')}
                        options={[
                            {
                                select: i18n.t(`frenet.yes`),
                                value: true,
                            },
                            {
                                select: i18n.t(`frenet.no`),
                                value: false,
                            },
                        ]}
                        value={false}
                        change={() => { }}
                    /> */}
              </div>
            </div>
            <div className='d-flex w-100 justify-content-between px-9 pb-5'>
              <Button
                text={i18n.t(`buttons.back`)}
                color='info'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => navigate('/configuracoes/taxa-entrega')}
                btnClass='fw-bolder'
              />
              <Button
                text={i18n.t(`buttons.save`)}
                color='primary'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => save()}
                btnClass='fw-bolder'
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const Frenet: FC = () => {
  const {id} = useParams()

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`ia.title_config`), path: 'ia/config', isActive: true},
          {title: i18n.t(`ia.config`), path: `ia/config/${id}`, isActive: true},
        ]}
      >
        {i18n.t(`ia.config`)}
      </PageTitle>
      <FrenetContent />
    </>
  )
}

export {Frenet}
